<script setup>
import {computed} from 'vue';
import {settingsBreadcrumbsForKey} from './breadcrumbs';

const breadcrumbs = computed(() => settingsBreadcrumbsForKey('navigation:backOffice.sidebar.myCompany.settings.appearance'));
</script>

<template>
    <div>
        <settings-appearance :breadcrumbs="breadcrumbs" />
    </div>
</template>

<style>
</style>
